
export const toUpperCase = value => value && value.toUpperCase();
